import React from 'react';
import { FaHardHat, FaBox, FaRulerCombined, FaTruck, FaMoneyBillWave, FaChartBar } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaHardHat />,
  2: <FaBox />,
  3: <FaRulerCombined />,
  4: <FaTruck />,
  5: <FaMoneyBillWave />,
  6: <FaChartBar />
};

const ConstructionIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="construction"
      gradient="#30cfd0 0%, #330867 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default ConstructionIndustryPage;

